/* eslint-disable import/no-named-as-default */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";

import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import utils from "./../../universal/utils";
import ChatIcon from "@material-ui/icons/Chat";
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import PersonIcon from "@material-ui/icons/Person";
import ContactUsIcon from "@material-ui/icons/MailOutline";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import AssessmentIcon from "@material-ui/icons/Assessment";

import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Divider from "@material-ui/core/Divider";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

// import { getCartItemsCount } from "./../../redux/reducers/utils/cart";
import { Typography } from "@material-ui/core";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";

import { GoogleLogin } from "@react-oauth/google";
import { ThemeModeContext } from "../../universal/ThemeModeContext";
import SecurityIcon from "@material-ui/icons/Security";
import SendIcon from "@material-ui/icons/Send";
import TrackChangesIcon from "@material-ui/icons/TrackChanges";
import WebIcon from "@material-ui/icons/Web";
import EventIcon from "@material-ui/icons/Event";
import {
  canManageAdminAccess,
  canViewFinance,
  canViewDashboard,
  canViewAnticheat,
  canViewGuard,
} from "../../universal/adminRoles";

const hebrewLabels = {
  shoppingCartCTA: "לעגלת קניות",
  mobileMenu: {
    home: "דף הבית",
    customerService: "שירות לקוחות",
    directSales: "שיטת המכירה הישירה",
    installPoints: "נקודות הרכבה",
    qanda: "שאלות ותשובות",
    aboutUs: "אודות ספורטישופ",
    contactUs: "צור קשר",
    testimonials: "מה אומרים עלינו",
  },
  footer: {
    privacyPolicy: "מדיניות פרטיות",
    termsOfUse: "תנאי השימוש",
    serviceMail: "service@sportyshop.co.il",
    servicePhone: "054&ndash;9200911",
  },
};

const basePath = utils.getEdgeBasePath();

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderBottom: `solid 1px ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: theme.zIndex.appBar,
  },
  themeToggle: {
    color: theme.palette.text.primary,
  },
  root: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "80%",
    maxWidth: "80%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
      maxWidth: "80%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "70%",
      maxWidth: "70%",
    },
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    marginRight: '0.5rem',
  },
  logoImg: {
    height: 33,
  },
  betaText: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  contentBarContainer: {
    display: "flex",
    alignItems: "center",
  },
  googleLoginContainer: {
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center"
  },
  contentBarLayout: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: '1.5rem',
  },
  containerAdminName: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.action.hover,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    borderRadius: "0.375rem",
    padding: "0.5rem 1rem",
  },
  adminName: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: theme.palette.text.primary,
    textTransform: "capitalize",
  },
  avatar: {
    width: '2.5rem',
    height: '2.5rem',
    fontWeight: 600,
    fontSize: "1rem",
    cursor: "pointer",
    transition: 'all 0.2s ease-in-out',
    "&:hover": {
      boxShadow: "0 0 0 2px #3b82f6",
    },
  },
  // Menu styles
  menuPaper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "0.5rem",
    padding: "0.25rem 0",
    minWidth: "15rem",
    maxHeight: "calc(100vh - 4.5rem)",
    overflowY: "auto",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  },
  menuItem: {
    padding: "0.3rem 0.75rem",
    color: theme.palette.text.primary,
    transition: "all 200ms ease-in-out",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "& .MuiListItemIcon-root": {
      color: theme.palette.text.secondary,
      minWidth: "2.5rem",
    },
    "& .MuiListItemText-primary": {
      color: theme.palette.text.primary,
      fontSize: "0.9rem",
      fontWeight: 500,
    },
  },
  userInfoSection: {
    padding: "0.6rem 0.75rem",
    backgroundColor: theme.palette.action.hover,
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: "0 0.25rem 0.25rem",
    borderRadius: "0.375rem",
  },
  userInfoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  avatarMenu: {
    width: '2.5rem',
    height: '2.5rem',
    fontWeight: 600,
    fontSize: "1rem",
    transition: 'all 0.2s ease-in-out',
  },
  userInfoText: {
    flex: 1,
  },
  userNickname: {
    color: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: 700,
    letterSpacing: '0.5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '7rem',
  },
  userFullName: {
    textTransform: "capitalize",
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '7rem',
  },
  menuDivider: {
    backgroundColor: theme.palette.divider,
    margin: "0.5rem 0",
  },
  menuSectionHeader: {
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    lineHeight: "1.75rem",
    paddingTop: "0.15rem",
    paddingBottom: 0,
    backgroundColor: theme.palette.background.paper,
    "&.MuiListSubheader-sticky": {
      backgroundColor: theme.palette.background.paper,
    },
  },
  menuItemLogout: {
    padding: "0.3rem 0.75rem",
    color: "#dc2626",
    transition: "all 200ms ease-in-out",
    "&:hover": {
      backgroundColor: "#fef2f2",
    },
    "& .MuiListItemIcon-root": {
      color: "#dc2626",
      minWidth: "2.5rem",
    },
    "& .MuiListItemText-primary": {
      color: "#dc2626",
      fontSize: "0.9rem",
      fontWeight: 500,
    },
  },
  "@media (min-width: 1024px)": {
    toolbar: {
      width: 1000,
      margin: "auto",
    },
    corona: {
      height: 65,
    },
    michelinPromoPre: {
      fontFamily: "Noto Sans Hebrew, sans-serif",
      color: "#ffffff",
      float: "left",
      position: "relative",
      left: 5,
      top: 0,
      fontSize: 21,
    },
    daysRange: {
      fontFamily: "Montserrat, sans-serif",
      color: "#ffe721",
      float: "right",
      position: "relative",
      right: 18,
      top: 24,
      fontSize: 25,
    },
    days: {
      fontFamily: "Montserrat, sans-serif",
      color: "#ffffff",
      float: "right",
      position: "relative",
      right: -9,
      top: 24,
      fontSize: 25,
    },
    menuNavToolBar: {
      width: 1000,
      margin: "auto",
    },
    logoutButtonCont: {
      position: "absolute",
      right: 0,
    },
    phoneIcon: {
      display: "none",
    },
    navBarButton: {
      color: "#fefefe",
      fontSize: "12pt",
    },
    logoutButton: {
      position: "relative",
      bottom: 1,
    },
    menuNavBarDesktop: {
      background: "#0085B2",
      position: "fixed",
      display: "initial",
      width: "100%",
      borderBottom: "solid 1px #555656",
      top: 66,
    },
    avatarName: {
      marginRight: 15,
    },
    logo: {
      position: "absolute",
      top: 16,
      left: 0,
    },
    rightIcon: {
      marginRight: 8,
    },
    accessibilityIcon: {
      left: "initial",
      right: 55,
    },
    cartIcon: {
      left: "initial",
      right: 16,
    },
  },

  list: {
    width: 250,
  },
  logoImg: {
    height: 33,
  },
  link: {
    textDecoration: "none",
  },
}));

export default function AppMenuBar({
  isAuthenticated,
  googleResponse,
  actions,
  onFailure,
  user = {},
  logout,
}) {
  const classes = useStyles();
  const { mode, toggleMode } = React.useContext(ThemeModeContext);
  const logoSrc =
    mode === "dark"
      ? "https://ouro-public-assets.s3.eu-west-2.amazonaws.com/init-logo-darkmode.png"
      : "https://ouro-public-assets.s3.eu-west-2.amazonaws.com/init-logo.png";

  React.useEffect(() => {
    actions.getTrackingVisitorId();
  }, [user]);

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const navigationGroups = [
    {
      key: "overview",
      label: "Overview",
      items: [
        canViewDashboard(user)
          ? { key: "dashboard", label: "Dashboard", to: "/dashboard", icon: <HomeIcon /> }
          : null,
      ].filter(Boolean),
    },
    {
      key: "users-support",
      label: "Users & Support",
      items: [
        { key: "users", label: "Users", to: "/users", icon: <PersonIcon /> },
        { key: "support", label: "Support Tickets", to: "/admin/support-tickets", icon: <ChatIcon /> },
        { key: "marketing-leads", label: "Marketing Leads", to: "/marketing-leads", icon: <MailOutlineIcon /> },
      ],
    },
    {
      key: "membership-finance",
      label: "Membership & Finance",
      items: [
        { key: "membership", label: "Membership", to: "/membership", icon: <MotorcycleIcon /> },
        canViewFinance(user)
          ? { key: "finance", label: "Finance", to: "/finance", icon: <AssessmentIcon /> }
          : null,
      ].filter(Boolean),
    },
    {
      key: "trust-safety",
      label: "Trust & Safety",
      items: [
        canViewDashboard(user)
          ? { key: "anticheat", label: "Anticheat", to: "/admin/anticheat", icon: <SecurityIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "anticheat-debugger", label: "AC Debugger", to: "/admin/anticheat-debugger", icon: <SecurityIcon /> }
          : null,
        canViewGuard(user)
          ? { key: "guard", label: "Ouro Guard", to: "/admin/guard", icon: <SecurityIcon /> }
          : null,
        canViewAnticheat(user)
          ? { key: "social-engagement", label: "Social Engagement", to: "/admin/social-engagement", icon: <SendIcon /> }
          : null,
      ].filter(Boolean),
    },
    {
      key: "administration",
      label: "Administration",
      items: [
        canManageAdminAccess(user)
          ? { key: "admin-access", label: "Admin Access", to: "/admin/access", icon: <MenuIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "email-campaigns", label: "Email Campaigns", to: "/admin/email-campaigns", icon: <SendIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "campaign-attribution", label: "Ad Attribution", to: "/admin/campaign-attribution", icon: <TrackChangesIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "templates", label: "Page Templates", to: "/admin/templates", icon: <WebIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "ui-experiments", label: "UI Experiments", to: "/admin/ui-experiments", icon: <TrackChangesIcon /> }
          : null,
        canViewDashboard(user)
          ? { key: "match-nights", label: "Match Nights", to: "/admin/match-nights", icon: <EventIcon /> }
          : null,
      ].filter(Boolean),
    },
  ].filter((group) => group.items.length > 0);

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logoContainer}>
            <a className={classes.logo} href="/">
              <img
                alt="Sportyshop"
                className={classes.logoImg}
                src={logoSrc}
              />
            </a>
            <Typography className={classes.betaText}>beta</Typography>
          </div>
          
          <div className={classes.contentBarContainer}>
            <Tooltip title={mode === "dark" ? "Switch to light mode" : "Switch to dark mode"}>
              <IconButton
                aria-label="toggle dark mode"
                onClick={toggleMode}
                className={classes.themeToggle}
                style={{ marginRight: "0.5rem" }}
                size="small"
              >
                {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
            </Tooltip>
            {isAuthenticated && user ? (
              <React.Fragment>
                <div className={classes.contentBarLayout}>
                  <div className={classes.containerAdminName}>
                    <Typography className={classes.adminName}>
                      {user.name || 'Admin'}
                    </Typography>
                  </div>
                  {user && user._id && (
                    <Avatar
                      className={classes.avatar}
                      alt={user.name}
                      src={user.picture}
                      ref={anchorRef}
                      aria-controls={open ? "menu-list-grow" : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                    />
                  )}
                </div>
              </React.Fragment>
            ) : (
              <div className={classes.googleLoginContainer}>
                <GoogleLogin
                  width={188}
                  onSuccess={googleResponse}
                  onFailure={onFailure}
                  auto_select
                  useOneTap
                />
              </div>
            )}
          </div>      
        </Toolbar>
      </AppBar>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        style={{ zIndex: 1300, marginTop: '0.5rem' }}
        transition
      >
        {({ TransitionProps, placement }) => {
          return (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "top right" : "top right",
              }}
            >
              <Paper className={classes.menuPaper}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                    style={{ padding: 0 }}
                  >
                    {/* Section 1: User Info */}
                    <div className={classes.userInfoSection}>
                      <div className={classes.userInfoContainer}>
                        <Avatar
                          src={user?.picture}
                          alt={user?.name || 'User'}
                          className={classes.avatarMenu}
                        />
                        <div className={classes.userInfoText}>
                          <div>
                            <Typography className={classes.userNickname}>
                              {user?.nickname || user?.name || 'User'}
                            </Typography>
                          </div>
                          <div>
                            <Typography className={classes.userFullName}>
                              {user?.given_name && user?.family_name 
                                ? `${user.given_name} ${user.family_name}`
                                : user?.nickname || user?.name || 'User'
                              }
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Divider className={classes.menuDivider} />

                    {navigationGroups.map((group, groupIndex) => (
                      <React.Fragment key={group.key}>
                        {groupIndex > 0 && <Divider className={classes.menuDivider} />}
                        <ListSubheader className={classes.menuSectionHeader}>
                          {group.label}
                        </ListSubheader>
                        {group.items.map((item) => (
                          <MenuItem
                            key={item.key}
                            className={classes.menuItem}
                            component={Link}
                            to={item.to}
                            onClick={handleClose}
                          >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText>{item.label}</ListItemText>
                          </MenuItem>
                        ))}
                      </React.Fragment>
                    ))}

                    <Divider className={classes.menuDivider} />

                    <MenuItem className={classes.menuItemLogout} onClick={logout}>
                      <ListItemIcon>
                        <ExitToAppIcon />
                      </ListItemIcon>
                      <ListItemText>Logout</ListItemText>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          );
        }}
      </Popper>
    </div>
  );
}

AppMenuBar.propTypes = {
  children: PropTypes.element,
  isAuthenticated: PropTypes.bool.isRequired,
  autoLoginInProgress: PropTypes.bool.isRequired,
  googleResponse: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  actions: PropTypes.object,
  catalog: PropTypes.object,
  classes: PropTypes.object,
};
